import { ReactNode, useState } from 'react'
import getQueryVariable from 'helpers/getQueryVariable'

import SearchContext from './SearchContext'

type Props = {
    children: ReactNode
}

const SearchProvider = ({ children }: Props) => {
    const [searchQuery, setSearchQuery] = useState(getQueryVariable('q') || '')

    return (
        <SearchContext.Provider value={{ searchQuery, setSearchQuery }}>
            {children}
        </SearchContext.Provider>
    )
}

export default SearchProvider
